import {get,post} from "./request.js"
import {SHOP_ID} from "@/store/mutation-types";


export function getSsInfo() {

    return get('/', {
        s:"App.AdminUser_MtSsUser.GetSsInfoFromSession",
    });
}

export function searchCustomerList(customerNameKensaku) {

    return get('/', {
        s:"App.Customer_Customer.customerList",
        customerNameKensaku: customerNameKensaku,

    });
}

export function searchCarList(customerId) {

    return get('/', {
        s:"App.Cars_Cars.carList",
        customerId: customerId,

    });
}
export function saveCustomerInfo(params) {

    return post('/', {
        s:"App.Customer_Customer.saveCustomerInfo",
        "name": params.name,
        "kensaku": params.kensaku,
        "customerName": params.customerName,
        "customerNameKensaku": params.customerNameKensaku,
        "zipCode": params.zipCode,
        "prefectures": params.prefectures,
        "municipalities": params.municipalities,
        "area":  params.area,
        "number": params.number,
        "buildingAndRoomNumber": params.buildingAndRoomNumber,
        "customerTelnumber": params.customerTelnumber,
        "shopId": localStorage.getItem(SHOP_ID)
    });
}

export function getEnquiteList(serviceType) {

    return get('/', {
        s:"App.Questionnaire_Questionnaire.questionnaireInfo",
        serviceType:serviceType
    });
}

export function saveEnquiteAnswer(shopId,customerId,carId,serviceStatus,questionAnswerlist) {

    return post('/', {
        s:"App.Questionnaire_Questionnaire.saveQuestionnaireAnswer",
        shopId:shopId,
        customerId:customerId,
        carId:carId,
        serviceStatus:serviceStatus,
        questionAnswerList:questionAnswerlist,
    });
}

export function addGeneralOrder(shopId,customerId,carId,serviceStatus) {

    return post('/', {
        s:"App.Order_Order.addGeneralOrder",
        shopId:shopId,
        customerId:customerId,
        carId:carId,
        serviceStatus:serviceStatus
    });
}

export function getFormCtrlInfo() {

    return get('/', {
        viewId:'customer',
        s:"App.Order_Order.getFormCtrlInfo",
    });
}

export function getAdInfo() {

    return get('/', {
        s:"App.Advertise_Advertise.list",
    });
}



